module.exports = __webpack_public_path__ + "img/parallax-image.ada15d90.svg";